export function createCreditTranslator(t) {
  const interpolate = (template, params = {}) =>
    Object.entries(params || {}).reduce(
      (acc, [key, val]) => acc.replace(new RegExp(`\\{${key}\\}`, "g"), String(val ?? "")),
      template
    );

  return (key, fallback, params) => {
    const value = params ? t(key, params) : t(key);
    if (!value || value === key) {
      return params ? interpolate(fallback, params) : fallback;
    }
    return value;
  };
}

export function normalizeDisplayText(value) {
  if (value == null || value === "") return value;
  return String(value).replace(/\s+/g, " ").trim();
}

export function formatDisclaimerText(value) {
  if (value == null || value === "") return value;
  return String(value)
    .replace(/[^\S\n]+/g, " ")
    .trim();
}
